import React from 'react';
import Box from '@amzn/meridian/box';
import Tag from '@amzn/meridian/tag';

export interface FilterTagsProps {
  /** The selected active-state values to render as removable chips (e.g. ['Yes','No']). */
  states: string[];
  /** Called with the state value when a chip's close control is clicked. */
  onRemove: (state: string) => void;
}

/**
 * FilterTags — removable Meridian chips for the selected active-state filters.
 * Ported as-is from v1 (design-system continuity: same Meridian Tag). Presentational:
 * `states` in, `onRemove` out; the parent (AssociateFilter) owns the selection.
 */
const FilterTags: React.FC<FilterTagsProps> = ({ states, onRemove }) => (
  <Box>
    <div className="filter-tag">
      {(states ?? []).map((state) => (
        <Tag key={state} onClose={() => onRemove(state)} type="theme">
          {state}
        </Tag>
      ))}
    </div>
  </Box>
);

export default FilterTags;
